import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

import BaseDialog from 'core/components/base-dialog/base-dialog';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';

import useStyles from './approve-task-modal.styles';

const ApprovalModal = ({ open, onClose, onApprove }) => {
  const classes = useStyles();

  return (
    <BaseDialog open={open} onClose={onClose} classes={{ paper: classes.container }}>
      <Label type="greenBig" className={classes.modalHeader}>
        Approve the provided documentation?
      </Label>
      <Label type="darkGreenSmall" className={classes.modalContent}>
        Approving will not notify the member or their agent. However, agents can see the task marked as approved in
        Staff.
      </Label>
      <Grid className={classes.btncontainer}>
        <Button variant="contained" color="secondary" className={classes.nobtn} onClick={onClose}>
          No, go back
        </Button>
        <Button variant="contained" color="primary" className={classes.yesbtn} onClick={onApprove}>
          Yes, approve task
        </Button>
      </Grid>
    </BaseDialog>
  );
};

ApprovalModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  taskName: PropTypes.string.isRequired,
  onApprove: PropTypes.func.isRequired,
  completedBy: PropTypes.string,
  rejections: PropTypes.arrayOf(PropTypes.shape({}))
};

export default ApprovalModal;
